/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  ItemState,
  ItemDetailDataState,
  ItemPutDataState
} from '@/types/master/item';
import _ from 'lodash';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    detailData: null,
    putData: null
  },
  mutations: {
    setDetail(state: ItemState, payload: ItemDetailDataState) {
      state.detailData = payload;
    },
    setPut(state: ItemState, payload: ItemPutDataState) {
      state.putData = payload;
    }
  },
  actions: {
    async fetch(context: any, itemMasterId: any) {
      await axios
        .get(getBaseUrl() + '/master/items/' + itemMasterId, {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setDetail', response.data);
          const setData = _.cloneDeep(response.data);
          delete setData.averageCost;
          context.commit('setPut', setData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, '単品情報が存在しません。');

            return router.push('/master/item');
          }
          if (e.response.status < 500) {
            error(e.response.status);

            return router.push('/master/item');
          }
          router.push('/error/server');
        });
    },
    async delete(context: any, itemMasterId: string) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .delete(getBaseUrl() + '/master/items/' + itemMasterId, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('success', '単品情報の削除に成功しました。');

          router.push('/master/item');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, '単品情報が存在しません。');
            return router.push('/master/item');
          }
          if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    },
    async put(context: any, payload: ItemPutDataState) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .put(
          getBaseUrl() + '/master/items/' + payload.id,
          {
            name: payload.name,
            model: payload.model,
            partCode: payload.partCode,
            categoryId: payload.categoryId,
            baseCost: payload.baseCost,
            caseCost: payload.caseCost,
            lotQty: payload.lotQty,
            leadTimeDay: payload.leadTimeDay,
            supplierId: payload.supplierId,
            subCategoryId: payload.subCategoryId,
            subSubCategoryId: payload.subSubCategoryId,
            isStock: payload.isStock,
            note: payload.note
          },
          {
            headers: { auth: await getAccessToken() }
          }
        )
        .then(() => {
          success('Success', '単品情報の変更に成功しました。');
          router.push('/master/item');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status == 404) {
            error(e.response.status, '単品情報が存在しません。');
            return router.push('/master/item');
          }
          if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
